/**
 * localStorage acumula 1 entrada por jogo (`complete_game_state_<id>`,
 * `final_ranking_<id>`, id = Date.now() da sessão) nos calculadores 8/12/16.
 * Só é limpa quando o utilizador carrega em "Novo Jogo" — sessões
 * abandonadas (fechar o separador, crash, trocar de app) ficam para
 * sempre e acabam por estourar a quota do browser (QuotaExceededError,
 * que depois impede QUALQUER escrita nova, incluindo o guardar do jogo
 * seguinte). Varre e apaga o que for mais antigo que `maxAgeMs`.
 *
 * NUNCA apaga o jogo que está em curso, por muito antigo que seja: num clube
 * o PC fica dias ligado com o mesmo jogo aberto (torneio de fim de semana), e
 * apagar-lhe o estado por ter passado das 24h seria perder o jogo ao vivo.
 */

/** Ids de sessão em curso (um por tamanho de jogo) — intocáveis. */
function idsAtivos(): Set<string> {
  const ativos = new Set<string>();
  try {
    for (const n of [6, 8, 12, 16]) {
      const id = localStorage.getItem(`current_game_session_id_${n}`);
      if (id) ativos.add(id.trim());

      const ativo = localStorage.getItem(`active_game_${n}_players`);
      if (ativo) {
        try {
          const dados = JSON.parse(ativo) as { id?: number | string };
          if (dados?.id != null) ativos.add(String(dados.id));
        } catch {
          /* entrada ilegível — ignora */
        }
      }
    }
  } catch {
    /* localStorage indisponível — devolve o que houver */
  }
  return ativos;
}

export function cleanupStaleGameState(maxAgeMs = 24 * 60 * 60 * 1000): void {
  const cutoff = Date.now() - maxAgeMs;
  const prefixos = ['complete_game_state_', 'final_ranking_', 'emergency_save_'];
  const protegidos = idsAtivos();

  try {
    // De trás para a frente: remover uma chave desloca os índices seguintes.
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const chave = localStorage.key(i);
      if (!chave) continue;
      const prefixo = prefixos.find((p) => chave.startsWith(p));
      if (!prefixo) continue;

      const idStr = chave.slice(prefixo.length);
      if (protegidos.has(idStr)) continue; // jogo em curso — não tocar

      const id = parseInt(idStr, 10);
      if (!Number.isNaN(id) && id < cutoff) {
        localStorage.removeItem(chave);
      }
    }
  } catch {
    // localStorage indisponível (modo privado, quota já esgotada) — ignora
  }
}
